import { createRoot } from "react-dom/client";
import App from "./App";
// Self-hosted fonts (font-display: swap by default) — replaces the
// render-blocking Google Fonts stylesheet and its third-party requests.
import "@fontsource-variable/inter/wght.css";
import "@fontsource-variable/inter/wght-italic.css";
import "@fontsource/bebas-neue/400.css";
import "./index.css";

createRoot(document.getElementById("root")!).render(<App />);
